import { render, staticRenderFns } from "./arealDistribution.vue?vue&type=template&id=e83f1062&scoped=true"
import script from "./arealDistribution.vue?vue&type=script&lang=js"
export * from "./arealDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83f1062",
  null
  
)

export default component.exports